module.exports = __webpack_public_path__ + "static/img/news4.e328b67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news4/news4.jpg
// module id = PcLo
// module chunks = 1